export default {"src":"/restaurant/_next/static/media/background.d38ede66.svg","height":202,"width":360,"blurWidth":0,"blurHeight":0};